import React, { useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import FactorySection from "../components/FactorySection";
import CampaignSlider from "../components/CampaignSlider";
import TechnologySection from "../components/TechnologySection";
import PartnerSection from "../components/PartnerSection";
import NewsSection from "../components/NewsSection";
import IrsBanner from "../components/IrsBanner";
import Footer from "../components/Footer";
import VideoModal from "../components/VideoModal";
import HailPopup from "../components/HailPopup";
import { ContactForm } from "../components/ContactForm";
import { InstagramFeed } from "../components/InstagramFeed";
import { brand } from "../mock/content";
import { t } from "../lib/ui";
import Seo from "../seo/Seo";

export default function Home() {
  const [video, setVideo] = useState(null);

  return (
    <div className="bg-black">
      <Seo path="/" />
      <Header />
      <main>
        <Hero />
        <div className="bg-black pb-[88px]" data-testid="home-irs-banner-wrap">
          <IrsBanner />
        </div>
        <CampaignSlider />
        <TechnologySection irsBordered showIrs={false} showStudy={false} mediaTall collapsibleCalc tightTop showClaim={false} mobileSlider showVesta="teaser" />
        <FactorySection onPlay={setVideo} />
        <PartnerSection />
        <NewsSection />

        {/* Lead capture */}
        <section id="parla-con-esperto" className="bg-black text-white py-20 md:py-28 border-t border-white/10 scroll-mt-24">
          <div className="max-w-[1440px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
            <div className="lg:col-span-5">
              <span className="text-white/60 text-[12px] uppercase tracking-[0.28em]" style={{ fontFamily: "Space Grotesk" }}>{t("home_cta_eyebrow")}</span>
              <h2 className="mt-5 font-black leading-[0.95] tracking-tight" style={{ fontFamily: "Archivo", fontSize: "clamp(2.2rem,5vw,4rem)" }}>
                {t("home_cta_t1")}<br />{t("home_cta_t2")}<span style={{ color: brand.yellow }}>{t("home_cta_accent")}</span>
              </h2>
              <p className="mt-6 max-w-md text-white/60 text-lg leading-relaxed" style={{ fontFamily: "Inter" }}>
                {t("home_cta_sub")}
              </p>
            </div>
            <div className="lg:col-span-7">
              <ContactForm source="Home" />
            </div>
          </div>
        </section>
      </main>
      <InstagramFeed />
      <Footer />
      {video && <VideoModal video={video} onClose={() => setVideo(null)} />}
      <HailPopup />
    </div>
  );
}
